.by{flex-shrink:0;}